import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Courses", href: "/courses" },
  { label: "Admissions", href: "/admissions" },
  { label: "Gallery", href: "/gallery" },
  { label: "Opportunities", href: "/opportunities" },
  { label: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 960) setMenuOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`} role="navigation" aria-label="Main navigation">
      <div className="navbar__inner">
        <button
          onClick={() => { navigate("/"); setMenuOpen(false); }}
          className="navbar__logo"
          aria-label="Mokorotlo College home"
          style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer" }}
        >
          <img
            src="/logo.jpeg"
            alt="Mokorotlo College of Creative Technology"
            width={48}
            height={48}
            className="navbar__logo-img"
            loading="lazy"
          />
          <span className="navbar__logo-text">
            <span className="navbar__logo-main">Mokorotlo College</span>
            <span className="navbar__logo-sub">Of Creative Technology</span>
          </span>
        </button>

        <ul className="navbar__links">
          {navLinks.map((link) => (
            <li key={link.label}>
              <NavLink
                to={link.href}
                className={({ isActive }) => `navbar__link ${isActive ? "navbar__link--active" : ""}`}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="navbar__actions">
          {user ? (
            <>
              {user.role === "webAdmin" && (
                <NavLink to="/admin-dashboard" className="btn btn--outline">Dashboard</NavLink>
              )}
              <button className="btn btn--outline" onClick={logout}>Logout</button>
            </>
          ) : (
            <NavLink to="/login" className="btn btn--outline">Login</NavLink>
          )}
          <NavLink to="/admissions" className="btn btn--accent">Apply Now</NavLink>
        </div>

        <button
          className="navbar__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-label="Toggle menu"
          type="button"
        >
          <span className={`hamburger-line ${menuOpen ? "open-1" : ""}`} />
          <span className={`hamburger-line ${menuOpen ? "open-2" : ""}`} />
          <span className={`hamburger-line ${menuOpen ? "open-3" : ""}`} />
        </button>
      </div>

      <div className={`navbar__mobile ${menuOpen ? "navbar__mobile--open" : ""}`}>
        {navLinks.map((link) => (
          <NavLink
            key={link.label}
            to={link.href}
            className="navbar__mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            {link.label}
          </NavLink>
        ))}
        <div className="navbar__mobile-actions">
          {user ? (
            <button className="btn btn--outline" onClick={() => { logout(); setMenuOpen(false); }}>Logout</button>
          ) : (
            <NavLink to="/login" className="btn btn--outline" onClick={() => setMenuOpen(false)}>Login</NavLink>
          )}
          <NavLink to="/admissions" className="btn btn--accent" onClick={() => setMenuOpen(false)}>Apply Now</NavLink>
        </div>
      </div>
    </nav>
  );
}
